import {
  GraphQLFieldConfig,
  GraphQLList,
  GraphQLNonNull,
  GraphQLObjectType,
  GraphQLString
} from 'graphql'
import { Context } from '../shared'
import {
  ApplicationQueryArgs,
  applicationQueryArgs
} from '../types/application-query-args'

type ApplicationArchitectureComponentType = 'db' | 'ws' | 'ldap'
type EncryptionStatusType = 'ENCRYPTED' | 'UNENCRYPTED' | 'UNKNOWN'

export interface ApplicationArchitectureComponent {
  readonly hash: string
  readonly type: ApplicationArchitectureComponentType
  readonly location: string
  readonly port: string
  readonly vendorName?: string
  readonly encryptionStatus: EncryptionStatusType
}

export const applicationArchitectureComponent = new GraphQLObjectType({
  name: 'ApplicationArchitectureComponent',
  description: 'A single application architecture component',
  fields: () => ({
    hash: {
      description: 'Component hash identifier',
      type: new GraphQLNonNull(GraphQLString)
    },
    type: {
      description: 'Component type',
      type: new GraphQLNonNull(GraphQLString)
    },
    location: {
      description: 'Component URL',
      type: new GraphQLNonNull(GraphQLString)
    },
    port: {
      description: 'Component URL Port',
      type: new GraphQLNonNull(GraphQLString)
    },
    vendorName: {
      description: 'Component vendor name ',
      type: GraphQLString
    },
    encryptionStatus: {
      description: 'Component encryption status',
      type: new GraphQLNonNull(GraphQLString)
    }
  })
})

export const applicationArchitectureComponents: GraphQLFieldConfig<
  any,
  Context,
  ApplicationQueryArgs
> = {
  description: 'Get architecture components by Application',
  type: new GraphQLNonNull(new GraphQLList(applicationArchitectureComponent)),
  args: applicationQueryArgs,
  async resolve(
    _source,
    { organizationID, applicationID },
    context
  ): Promise<ApplicationArchitectureComponent[]> {
    const { components } = await context.connector.get(
      `/${organizationID}/flowmap/${applicationID}/components`
    )

    return normalizeAppArchitectureComponents(components)
  }
}

function normalizeAppArchitectureComponents(
  components
): ApplicationArchitectureComponent[] {
  return components.map(
    ({ type, url, remote_port, vendor_name, encryption_status, hash }) => {
      return {
        hash,
        type,
        location: url,
        port: remote_port,
        vendorName: vendor_name,
        encryptionStatus: encryption_status
      }
    }
  )
}
